// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 7279 ? "b1644e8c" : chunkId) + "." + {"1068":"3b23becf662e1a65","5223":"d5192df72e852dea","7279":"51d3d0b2932cc8c7"}[chunkId] + ".js";
};